import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EventService } from 'src/service/event.service';
import { FilterBaseComponent } from '../filter-base-component';

@Component({
    selector: 'app-filter-text',
    templateUrl: './filter-text.component.html',
    styleUrls: ['./filter-text.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FilterTextComponent extends FilterBaseComponent implements OnInit, OnDestroy {
  public value: string = "";

  constructor(protected _eventService: EventService, protected _translateService: TranslateService) {
    super(_eventService, _translateService);
  }

  ngOnInit() {
    this.baseSubscribeTranslationEvent();
    this.baseLoadTranslation();
  }

  ngOnDestroy(): void {
    this.baseOnDestroy()
  }

  // On ionBlur send value of filter
  public valueChanged(event) {
    this._eventService.OnFilterValueChanged.next([this.Filter, event]);
  }

}
